<template>
  <Head title="Pemakai" />
  <div class="card card-outline card-primary">
    <div class="card-header">
      <h3 class="card-title">DAFTAR PEMAKAI</h3>
      <div class="card-tools">
        <Link href="/home" class="btn btn-tool"><i class="fas fa-times"></i></Link>
      </div>
    </div>
    <div class="card-body table-responsive">
      <data-table :columns="columns" :ajax="{ url: '/datatables/user' }" ></data-table>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/Master'
import { Head, Link, router } from '@inertiajs/vue3'
import DataTable from '@/Forms/DataTable'

export default {
  layout: Layout,
  components: {
    Head,
    Link,
    DataTable,
  },
  data() {
    return {
      columns: [
        { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
        { title: 'Nama Lengkap', data: 'name' },
        { title: '', data: 'photo', orderable: false, searchable: false },
        { title: 'Email', data: 'email' },
        { title: 'Telepon', data: 'phone' },
        { title: 'Last Login', data: 'waktu' },
        { title: 'Last IP', data: 'last_ip' },
        { title: 'Status', data: 'status', orderable: false, searchable: false },
        { title: 'Aksi', data: 'action', orderable: false, searchable: false }
      ],
    }
  },
  mounted() {
    $('body').on('click', '.btn-delete', function (event) {
      event.preventDefault();
      let name = $(this).attr('id');
      let url = $(this).attr('href');
      Swal.fire({
        title: name,
        text: "Yakin data ini dihapus",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Ya, hapus!',
        cancelButtonText: 'Batal'
      }).then((result) => {
        if (result.isConfirmed) {
          router.delete(url, {
            onSuccess: page => {
              toastr.success('Hapus Pemakai berhasil', 'SUKSES')
              $('#dt-table').DataTable().ajax.reload();
            },
            onError: errors => {
              toastr.error(errors.message, 'GAGAL')
            },
          })
        }
      })
    });
  }
}
</script>
